<template>
    <div>
        <draggable v-model="project.blocks" :options="{draggable:'.list-group-item'}" class="list-group mt-4"
                   @end="saveOrder">
            <router-link v-for="block in project.blocks"
                         :to="{name: entity.replace('_', '-') + '-edit-block', params: {blockId: block.id}}"
                         class="list-group-item list-group-item-action dd-flex align-items-center"
                         :key="block.id">
                {{block.name.text}} <span v-if="block.currentVersionId === 0" style="font-size: 0.5em;">(offline)</span>
                <a href="#" class="ml-auto" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, block),
                            message: 'Bist du sicher, dass du den Block <strong>'+block.name.text+'</strong> löschen möchtest?'}"><i
                        class="fa fa-trash fa-fw"></i></a>
            </router-link>
        </draggable>

        <hr>
        <a href="#" class="btn btn-success" style="margin-top: auto;"
           @click.prevent="showCreateModal = true">Hinzufügen</a>

        <b-modal ref="modal" v-model="showCreateModal" @ok="add">
            <h1 slot="modal-title">Block hinzufügen</h1>
            <div class="admin-info">
                Der "Name" wird in der Navigation der Seite angezeigt. Der Navigationspunkt kann optional auch
                ausgeblendet werden. Der Text im Block kann dann von beliebigen anderen Titeln gegliedert werden, ist
                also nicht abhängig vom eingestellten Name.
            </div>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="newBlockName" class="form-control">
            </div>
            <div class="form-group">
                <label for="name">Typ</label>
                <select type="text" id="type" v-model="newBlockType" class="form-control">
                  <template v-if="entity == 'program_resumee'">
                    <option value="ResumeeBlock">Resumee Kapitel</option>
                  </template>
                  <template v-else>
                    <option value="ImageBlock">Text / Bild</option>
                    <option value="FilmBlock">Film</option>
                    <option value="ImageGalleryBlock">Bildergalerie</option>
                    <option value="KeyResultsBlock">Carousel-Slider</option>
                    <option value="ProjectProductsBlock">Akkordeon</option>
                    <option value="QuotationBlock">Zitat</option>
                  </template>
                </select>
            </div>
        </b-modal>

    </div>
</template>
<script>
export default {
  props: ["data", "entity"],
  data() {
    return {
      showCreateModal: false,
      project: this.data,
      newBlockName: "",
      newBlockType: this.entity == "program_resumee" ? "ResumeeBlock" : "ImageBlock"
    };
  },
  methods: {
    add() {
      let form = new FormData();
      form.append("create_block[name]", this.newBlockName);
      form.append("create_block[type]", this.newBlockType);
      form.append("create_block[position]", this.project.blocks.length);
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" +
            store.state.language +
            "/" +
            this.entity +
            "/" +
            this.data.id +
            "/create_block",
          form
        )
        .then(({ data }) => {
          this.project.blocks.push(data.result);
          this.newBlockName = "";
          this.newBlockType = "ImageBlock";
          store.commit("finishSavingProcess");
        });
    },
    saveOrder() {
      let blockIds = [];
      for (
        let position = 0;
        position < this.project.blocks.length;
        position++
      ) {
        blockIds.push(this.project.blocks[position].id);
      }
      store.commit("addSavingProcess");
      axios
        .post("/api/" + store.state.language + "/block/set_block_order", {
          blocks: blockIds
        })
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        });
    },
    remove(dialog, block) {
      axios
        .post("/api/" + store.state.language + "/block/" + block.id + "/delete")
        .then(({ data }) => {
          if (data.success) {
            this.project.blocks.splice(this.project.blocks.indexOf(block), 1);
          }
        });
    }
  }
};
</script>
<style scoped>
.list-group {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/block/List.vue